import { navigate } from "@reach/router";
import { observer, inject } from "mobx-react";
import Button from "components/Button";
import eventStop from "components/ReactUtils/eventStop";
import FormStore from "components/Form/FormStore";
import Input from "components/Form/Input";
import queryString from "query-string";
import React, { Component } from "react";

class AuthFormPasswordNew extends Component {
  store = new FormStore({
    data: {
      password: "",
    },
    constraints: {
      password: {
        presence: { message: "Bitte füllen Sie dieses Feld aus." },
      },
    },
  });

  save = async e => {
    const { api } = this.props;

    eventStop(e);

    if (!(await this.store.validate())) {
      const { password } = this.store.toJS();

      const query = queryString.parse(window.location.search);
      const tempToken = query.token;

      await api
        .post("authPasswordNew", { tempToken, password, modelName: "Store" })
        .then(({ token, redirectLink }) => {
          api.setToken(token);

          navigate(`/login/new-password/saved?redirect=${redirectLink}`);
        })
        .catch(({ error }) => this.store.setError("password", error.message));
    }
  };

  render() {
    const { className } = this.props;

    return (
      <div className={[className, "text-center"].join(" ")}>
        <div>
          <strong>Passwort zurücksetzen</strong>
        </div>
        <br />
        <div>Bitte geben Sie Ihr neues Passwort ein:</div>
        <br />
        <form onSubmit={this.save}>
          <div className="_inputs">
            <Input type="password" store={this.store} name="password" label="Passwort eingeben" />
          </div>
          <div>
            <Button type="submit">PASSWORT SPEICHERN</Button>
          </div>
        </form>
      </div>
    );
  }
}

AuthFormPasswordNew = observer(AuthFormPasswordNew);
AuthFormPasswordNew = inject("api")(AuthFormPasswordNew);

export default AuthFormPasswordNew;
